

import DistanceLegend from "./type/DistanceLegend"
import LocationBar from "./type/LocationBar"
import Compass from "./type/Compass"
import ZoomController from "./type/ZoomController"
export default function createWidgets() {
    return {
        distanceLegend: new DistanceLegend(),
        locationBar: new LocationBar(),
        compass: new Compass(),
        zoomController:new ZoomController()
    }
}